enum ValidationRuleType{
    REGEX="REGEX",
    COMPARE="COMPARE",
    CUSTOM="CUSTOM",
    MAXLENTH="MAXLENTH",
    EXTERNAL="EXTERNAL"
}

export default ValidationRuleType;